let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iREv5")).then(() => parcelRequire('fbHnC'));